import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as selectors from './state-selectors/bank-search';
import bankSearchConfig from './bankSearchConfig';

export class BankSearch extends Component {

    componentDidMount() {
        this.initSearchWidget();
    }

    render() {
        let { widgetArgs } = this.props;
        const widgetId = widgetArgs && widgetArgs.provider === 'plaid' ? 'search-widget-plaid' : 'search-widget';
        return (
            <div id="bankSearch">
                <div id={widgetId}></div>
            </div>
        );
    }

    initSearchWidget() {
        let {
            widgetArgs,
            searchUrl
        } = this.props;

        const isPlaid = widgetArgs && widgetArgs.provider === 'plaid';

        new PlaidWidget({
            searchUrl,
            searchFilter: isPlaid ? window.globalConfig.plaidSearchFilter : window.globalConfig.decisionLogicSearchFilter,
            ...widgetArgs,
            ...bankSearchConfig.bankSearchWidget,
            applyTo: isPlaid ? 'search-widget-plaid' : 'search-widget'
        });
    }
}

BankSearch.propTypes = {
    searchUrl: PropTypes.string,
};

const mapStateToProps = (state, props) => {
    const { searchEndPoint, userType, loanId } = props;
    return {
        searchUrl: selectors.getSearchUrl(state, loanId, searchEndPoint, userType),
    };
};

export default connect(mapStateToProps, null)(BankSearch);
